import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

/** Only considere recaptcha enabled when frontegg and recaptcha feature flags are enabled */
export const useIsRecaptchaEnabled = (): boolean => {
  const [recaptchaEnabled] = useFlowFeature('recaptcha')

  return recaptchaEnabled
}
